import { MileageBreakevenCalculator } from '../components/calculator/MileageBreakevenCalculator';
import React from "react";

export default function CalculatorPage() {
    return (
        <div>
            <MileageBreakevenCalculator />
        </div>
    );
}